<div mat-dialog-content>
  <div class="flex flex-col">
    <span class="font-semibold text-lg">Change of Ownership</span>
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-4">
        <span>The following are the steps for an IHC change of ownership. A license is specific to an owner and is not transferrable.
          Therefore, a new license must be generated when a change of ownership occurs. The steps to be completed are:</span>
        <span>1. Seller must submit an owner agreement letter which notifies this office of the change of ownership with the effective date;</span>
        <span>2. Buyer must also sign the above letter, or may submit a separate letter which confirms the change of ownership with effective date;</span>
        <span>5. Owner/Administrator Background Check Request forms must be submitted in conjunction with the application as applicable;</span>
        <span>6. Change of ownership fee must be submitted which is $350.00;</span>
        <span>8. The old license must be returned after the change of ownership effective date and once the new license is received.</span>
        <span>The Oregon Administrative Rules OARs for IHCs with which the new owner must comply, the IHC application form,
              the applicable background check forms for the administrator or owner(s), if applicable,
              are found at <a href="http://www.healthoregon.org/hcrqi">www.healthoregon.org/hcrqi</a></span>
      </div>

      <div class="flex flex-col md:flex-row md:gap-4" *ngIf="subunits.length > 0">
        <div class="flex flex-col gap-2 md:w-1/2">
          <div class="flex flex-col md:flex-row gap-2">
            <span class="font-semibold text-lg">Select any subunits being transferred</span>
          </div>
            <mat-checkbox *ngFor="let subunit of subunits" [checked]="subunitSelected(subunit.licenseId)"
                          (change)="selectSubunit(subunit)">
              <div class="flex flex-row gap-2">
                <span>{{subunit.licenseId}}</span>
                <span>{{subunit.agencyDBAName}}</span>
              </div>
            </mat-checkbox>
        </div>
        <div class="flex flex-col gap-2 md:w-1/2">
          <div class="flex flex-col md:flex-row gap-2">
            <span class="font-semibold text-lg">If keeping multiple subunits, choose a new parent</span>
          </div>
          <mat-radio-group [(ngModel)]="parentGuid">
            <mat-radio-button *ngFor="let subunit of subunits" [value]="subunit.licenseId" (change)="validateParent(subunit.licenseId)">
              <div class="flex flex-row gap-2">
                <span>{{subunit.licenseId}}</span>
                <span>{{subunit.agencyDBAName}}</span>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <span class="font-semibold text-lg">Add each new owner</span>
      <mat-card>
        <mat-card-content>
          <entity-owner *ngIf="changeData.changeAction !== sharedService.delete && change.id > 0"
                        [entityId]="change.id"
                        [entityType]="sharedService.inHomeCareChange"
                        [entityGuid]="changeData.licenseGuid"
                        [isChange]="true">
          </entity-owner>
        </mat-card-content>
      </mat-card>
    </div>

    <!--
      Required Documents
    -->
    <document class="mt-4"
              [entityId]="change.id"
              [entityType]="sharedService.inHomeCareChange"
              [types]="ownerDocumentTypes"></document>

    <!--
     Submit
    -->
    <div class="flex flex-col pt-4">
      <div class="flex flex-col" *ngIf="validationErrors.length > 0">
        <span class="font-semibold text-xl portal-error">Missing Information</span>
        <div class="flex flex-col gap-2 portal-error">
          <span *ngFor="let error of validationErrors">{{error}}</span>
        </div>
      </div>
      <form [formGroup]="changeForm">
        <div class="flex flex-col">
          <div class="flex flex-col md:flex-row gap-2">
            <div class="flex flex-col gap-2">
              <span class="font-semibold">Effective Date</span>
              <mat-form-field>
                <input placeholder="mm/dd/yyyy" formControlName="effectiveDateOfChange" matInput [matDatepicker]="effectiveDateOfChange"
                [min]="sharedService.today" [max]="thirtyDays" />
                <mat-datepicker-toggle matSuffix [for]="effectiveDateOfChange"></mat-datepicker-toggle>
                <mat-datepicker #effectiveDateOfChange>
                  <mat-datepicker-actions>
                    <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                    <button mat-button matDatepickerCancel>Cancel</button>
                  </mat-datepicker-actions>
                </mat-datepicker>
                <mat-error *ngIf="changeForm.get('effectiveDateOfChange').invalid">
                  Effective date required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row gap-4 ml-auto">
            <button *ngIf="changeForm.valid" mat-button type="button" color="primary" (click)="submitChange()">Submit</button>
            <button *ngIf="newChangeAdded" mat-button type="button" color="warn" (click)="cancel()">Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
